import { Group, LoadingOverlay, Select, Stack } from '@mantine/core';
import { FC, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DatasetsInfo, useBot, queryBotDatasetsList } from '@mygpt/app';

export interface FaqsDatasetFormProps {
  value?: string;
  onChange: (value: string | null) => void;
  disabled?: boolean;
}

export const FaqsDatasetForm: FC<FaqsDatasetFormProps> = ({ disabled, onChange, value }) => {
  const { t } = useTranslation();
  const { botId } = useBot();
  const [loading, setLoading] = useState(true);
  const [datasets, setDatasets] = useState<DatasetsInfo[]>([]);
  const initRef = useRef(true);
  useLayoutEffect(() => {
    queryBotDatasetsList({
      aiId: botId,
      size: 1000,
    })
      .then((res) => {
        const list = res.data.items;
        setDatasets(list);
      })
      .finally(() => {
        setLoading(false);
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch((err) => {});
  }, [botId]);

  useLayoutEffect(() => {
    if (initRef.current && datasets.length > 0 && !value) {
      onChange(datasets[0].id);
      initRef.current = false;
    }
  }, [datasets, onChange, value]);

  return (
    <Stack>
      <Group gap="xs" className="relative">
        <LoadingOverlay loaderProps={{ size: 'xs' }} visible={loading} overlayProps={{ blur: 2 }} />
        <Select
          label={<label className="text-sm">{t('embeddings.dataset.add_modal.desc')}</label>}
          withAsterisk
          className="w-full"
          size="xs"
          allowDeselect={false}
          disabled={disabled}
          value={value || datasets[0]?.id}
          onChange={onChange}
          data={datasets.map((value) => ({ value: value.id, label: value.name }))}
        />
      </Group>
    </Stack>
  );
};
